import React from "react";

import NotificationComponent from "~/pages/CharacterSheet/widgets/RollNotification/Notification";
import styles from "~/pages/CharacterSheet/widgets/RollNotification/NotificationContainer.module.scss";
import { Notification } from "~/pages/CharacterSheet/types";

export interface NotificationContainerProps {
  notifications: Notification[];
  onDismiss: (id: string) => void;
}

/**
 * Container for managing multiple notification toasts (rolls and tag actions).
 * Displays notifications stacked in the top-right corner.
 */
const NotificationContainer: React.FC<NotificationContainerProps> = ({
  notifications,
  onDismiss,
}) => {
  if (notifications.length === 0) return null;

  return (
    <div className={styles.container}>
      {notifications.map((notification) => (
        <NotificationComponent
          key={notification.data.id}
          notification={notification}
          onDismiss={onDismiss}
        />
      ))}
    </div>
  );
};

export default NotificationContainer;
